import { Component } from 'react';
import { BlockInstanceProps } from '../Block';
import SideboxComponent from '../../components/Sidebox';
import {
  BackgroundColorEnum,
  ContentTypeEnum,
} from '../../constants/cms-constants';
import controlOptionDefinitions from '../../utils/controlOptions/controlOptionDefinitions';
import {
  ComponentWithControlOptions,
  ControlOption,
} from '../../utils/controlOptions/ControlOptionDecorator';

@ControlOption([
  {
    key: 'fontColor',
    definition: controlOptionDefinitions.fontColor,
  },
  {
    key: 'backgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'factBoxBackgroundColor',
    definition: controlOptionDefinitions.backgroundColor,
  },
  {
    key: 'seoWeight',
    definition: controlOptionDefinitions.SEOWeightTypes,
  },
])
class SideboxBlock extends ComponentWithControlOptions<BlockInstanceProps> {
  render() {
    const { block, blockContent } = this.props;
    const { header, bodyText } = block;
    const controlOptions = block?.controlOptionsV2;
    const backgroundColor =
      BackgroundColorEnum[controlOptions?.backgroundColor];
    const factBoxBackgroundColor =
      BackgroundColorEnum[controlOptions?.factBoxBackgroundColor];
    const fontColor = controlOptions?.fontColor;
    const seoWeight = controlOptions?.seoWeight;

    let image;
    let video;
    let factBoxContent;
    blockContent.doQuery((content) => {
      image = content.getFirstOfType(ContentTypeEnum.IMAGE, false);
      video = content.getFirstOfType(ContentTypeEnum.VIDEO, false);
      factBoxContent = content.getFirstOfType(ContentTypeEnum.MEDIAITEM, false);
    });

    return (
      <SideboxComponent
        headerText={header?.main}
        text={bodyText}
        image={image}
        video={video}
        factBoxTitleText={factBoxContent?.header}
        factBoxBodyText={factBoxContent?.bodyText}
        factBoxFontColor={fontColor}
        factBoxBackgroundColor={factBoxBackgroundColor}
        backgroundColor={backgroundColor}
        seoWeight={seoWeight}
      />
    );
  }
}

export default SideboxBlock;
